<!--
 * @Author: wanglibo
 * @LastEditors: wanglibo
 * @Description: 营养门诊-营养认知评估
-->

<template>
  <div class="bodyinfo-page">
    <div class="title">营养认知评估</div>
    <div class="form-wrapper">
      <van-form @submit="onSubmit" :scroll-to-error="true">
        <div class="form-item" v-for="item in qsList" :key="item.name">
          <div class="form-item-label">{{ item.label }}</div>
          <div class="form-item-input">
            <van-field :name="item.name" :rules="[{ required: true, message: '请选择' }]">
              <template #input>
                <van-radio-group v-model="formData[item.name]" direction="vertical" icon-size="1.33rem">
                  <van-radio class="van-radio__label" v-for="opt in item.options" :key="opt.key" :name="opt.key"
                    checked-color="#FBB13D">{{ opt.label }}</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </div>
        </div>


        <div class="next-btn-wrapper">
          <van-button round block color="#FBB13D" native-type="button" plain @click="onClickPrev">上一页</van-button>
          <van-button round block color="#FBB13D" type="info" native-type="submit">下一页</van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
// import {getQueryString} from '../utils/utils'
export default {
  name: 'NutritionalAwareness',
  props: {
    initData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      qsList: [{
        label: '1.选购食品时是否查看营养成分表？',
        name: 'nutritionIsKnowIngredient',
        options: [{
          label: "每次查看",
          key: '1'
        }, {
          label: "偶尔查看",
          key: '2'
        }, {
          label: "从不查看",
          key: '3'
        }]
      }, {
        label: '2.能否识别隐形糖（如果葡糖浆、麦芽糊精等）？',
        name: 'nutritionIsKnowHiderSugar',
        options: [{
          label: "可识别≥3种",
          key: '1'
        }, {
          label: "识别1-2种",
          key: '2'
        }, {
          label: "不会识别",
          key: '3'
        }]
      }],
      formData: {
      }
    }
  },
  created() {

  },
  mounted() {
    this.formData = {...this.initData}
  },
  methods: {
    onSubmit(values) {
      let query = { ...values }
      console.log('onSubmit', values, query);
      this.$emit('next-step',{type:'nutritionalAwareness',data:query})
    },
    onClickPrev() {
      this.$emit('prev-step')
    }
  }
};
</script>

<style scoped>
div,
p,
ul,
li,
* {
  box-sizing: border-box;
}

.bodyinfo-page {
  width: 100%;
  height: 100vh;
  padding: 2rem;
  background-color: #fff;
}

.bodyinfo-page .title {
  height: 2.33rem;
  font-weight: 500;
  font-size: 1.67rem;
  color: #333333;
  line-height: 2.33rem;
  margin-bottom: 2rem;
}

.form-wrapper {
  padding-bottom: 5rem;
}

.form-wrapper .form-item {
  margin-bottom: 2rem;
}

.form-wrapper .form-item .form-item-label {
  font-weight: 500;
  font-size: 1.33rem;
  color: #333333;
  line-height: 1.83rem;
  text-align: left;
  margin-bottom: 1rem;
}

.form-wrapper .form-item .form-item-input {
  /* width: 100%;
  height: 3.5rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  background: #F8F9FA; */
}

.icon-mark {
  width: 100px;
  font-size: 1.17rem;
}

.form-wrapper .form-item .form-item-input .van-cell {
  /* background: #F8F9FA; */
  padding-left: 0;
  border-bottom: 1px solid #e8e9ec;
}

.next-btn-wrapper {
  width: 100%;
  height: 6.9rem;
  display: flex;
  gap: 1.42rem;
  background-color: #fff;
  position: fixed;
  z-index: 99;
  bottom: 0;
  left: 0;
  padding: 0.33rem 2rem;
  box-shadow: inset 0rem 0.04rem 0rem 0rem rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(10px);
}

.form-wrapper .form-item .van-radio__label,
.bodyinfo-page .van-radio__label {
  font-size: 1.33rem;
  margin-bottom: 1rem;
}
</style>
